import { ThemeProvider } from '@material-ui/core/styles';
import i18n from 'i18next';
import * as React from 'react';
import { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Navigate, Route, Routes } from 'react-router';
import { HashRouter } from 'react-router-dom';
import BottomBar from './components/BottomBar';
import RegisterScreen from './components/RegisterScreen';
import VerifyEmailScreen from './components/VerifyEmailScreen';
import './registerIndex.css';
import RedirectToPaymentInsiderService from './services/RedirectToPaymentInsiderService';
import { theme } from './theme/theme';
import { PaymentInsiderParams } from './models/PaymentInsiderParams';

require('./signatures.css');

declare const document;
const params = new URLSearchParams(window.location.href.split('?')[1]);
const locale = params.get('locale');
if (locale === 'pl_PL') {
  i18n.changeLanguage('pl');
} else if (locale === 'fr_CA') {
  i18n.changeLanguage('fr');
}
const jurisdictionCode = params.get('jc');
const subJurisdictionCode = params.get('sj');
const offering = params.get('offering');
const bypassCiam = params.get('bypassCIAM');

if (!bypassCiam) {
  const paymentInsiderParams: PaymentInsiderParams = {
    jurisdictionCode,
    subJurisdictionCode,
    locale,
    offering,
  } as PaymentInsiderParams;
  RedirectToPaymentInsiderService.redirectToPaymentInsider(paymentInsiderParams)
    .subscribe((shouldRedirect: boolean) => {
      if (!shouldRedirect) {
        renderDom();
      }
    });
} else {
  renderDom();
}

function renderDom() {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <HashRouter>
        <>
          <div style={{
            margin: '0 auto', maxWidth: '350px', marginTop: '3em', paddingBottom: '70px',
          }}
          >
            <Routes>
              <Route path="/register" element={<RegisterScreen />} />
              <Route path="/verifyEmail" element={<VerifyEmailScreen />} />
              <Route path="*" element={<Navigate to="/register" replace />} />
            </Routes>
          </div>
          <BottomBar
            jurisdictionCode={jurisdictionCode}
            locale={locale}
            subJurisdictionCode={subJurisdictionCode}
            contactInfoUri="/sb/md/getJurisdictionInfo"
          />
        </>
      </HashRouter>
    </ThemeProvider>,
    document.getElementById('self-board-root'),
  );
}

// Recapcha
const recapchaElement = document.createElement('script');
recapchaElement.src = 'https://www.google.com/recaptcha/api.js?render=6LcG9ncUAAAAAI7laZhfyrjCKUgr03x21rWAYpJe';
document.head.appendChild(recapchaElement);
